import React from 'react' // ,{useState} 
import classes from './FileUploaderCard.module.css'
import { getFileIconCss } from '../../../Utility'

const FileUploaderCard = ({
    title,
    containerclassName='',
    fileid,
    fileInputDivClassName='',
    filename,
    tootltipInfo=''

}) => {
    return (
        <div className={`${containerclassName}`}>
            {
                // console.log(filename)
            }
            <div className={classes['Label-Row']}>
            <label className={`col-form-label ${classes['customLabel']}`}>{title}
            <i className={`fa fa-info-circle ${classes['info-icon']}`}  data-toggle="tooltip" data-placement="top" title={tootltipInfo}/>
            </label>
            </div>
            
            <div className={`${fileInputDivClassName}`} onClick={e=>document.getElementById(fileid).click()}>
                {filename? 
                <div className={classes['file-type-Image-Container']}>
                    <img src={getFileIconCss(filename).icon} alt=""/>
                    <a className="btn btn-primary">Change</a>
                </div>
                :
                <i className="fa fa-plus" />
                }
            </div>
        </div>
    )
}



export default FileUploaderCard
